module.exports = __webpack_public_path__ + "static/media/related-blog1.19ba8090.jpg";